export default function(date) {
  const tempDate = date.slice(0, 10);
  const splitedDate = tempDate.split('-');
  const month = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ][Number(splitedDate[1]) - 1];
  const formatedDate = splitedDate[2] + '-' + month + '-' + splitedDate[0];
  return formatedDate;
}
